<section id="footer">
    <a href="https://www.facebook.com/"><i class="fa fa-facebook social-icon"></i></a>
    <a href="https://www.instagram.com/"><i class="fa fa-instagram social-icon"></i></a>
    <a href="https://twitter.com/login"><i class="fa fa-twitter social-icon"></i></a>
    <a href="https://www.google.com/intl/en_in/gmail/about/"><i class="fa fa-envelope social-icon"></i></a>
    <a href="https://contacts.google.com/"><i class="fa fa-phone social-icon"></i></a>
    <br>
    <span style="font-family:'Montserrat', sans-serif; font-weight: bold;">&copy; Copyright 2020 Fan-nation</span>
</section>